import { render } from "./EditModal_Kojin.vue?vue&type=template&id=48e5ac28"
import script from "./EditModal_Kojin.vue?vue&type=script&lang=js"
export * from "./EditModal_Kojin.vue?vue&type=script&lang=js"

import "./EditModal_Kojin.vue?vue&type=style&index=0&id=48e5ac28&lang=css"

import exportComponent from "/codebuild/output/src327471177/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__